import styled from 'styled-components'
import * as C from '../util/Colors'
import * as F from '../util/Fonts'

export const Template = styled.div`
    width:100%;
    background-color:${C.GREY_LIGHT};
    padding:0;
    margin:0;
    height: 100%;
    max-width: 100%;
`

export const Div = styled.div``

export const Span = styled.span``

export const I = styled.i``

export const H1 = styled.h1``
export const H2 = styled.h2``
export const H3 = styled.h3``
export const H4 = styled.h4``
export const H5 = styled.h5``
export const H6 = styled.h6``
export const P  = styled.p``

export const TBody = styled.tbody``

export const Input = styled.input``

export const Select = styled.select`
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 2.5;
    color: ${C.GREY_FONT};
    background-color: ${C.WHITE};
    background-clip: padding-box;
    border: 1px solid #ced4da;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    margin: 15px 5px;
    box-shadow: 1px 1px 0px 0px lightgrey;
    height:62px;

    &::placeholder {
        color: ${C.GREY_FONT};
    }
    &:-ms-input-placeholder {
        color: ${C.GREY_FONT};
    }
    &::-ms-input-placeholder {
        color: ${C.GREY_FONT};
    }
`

export const Option = styled.option``

export const IMG = styled.img``



export const HR = styled.hr`
    margin: 20px 0;
`

export const PADD = styled.section`
    padding: 0 10px
`





export const Text = styled.h3`
    color:${C.WHITE};
    font-size:14px;
    margin-top:10px
`

export const PrimaryButtom = styled.button`
    cursor:pointer;
    font-size: ${F.SIZE_TEXT};
    font-weight: bold;
    text-align:center;
    color:${C.WHITE};
    background-color:${C.BLUE};
    width: 300px;
    height: 50px;
    border-color: ${C.BLUE};
    margin: 30px auto;
    border: 1px solid transparent;
    font-size: 20px;
    line-height: 2;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    -moz-transition: all .2s ease-in;
    -o-transition: all .2s ease-in;
    -webkit-transition: all .2s ease-in;
    transition: all .2s ease-in;

    &:hover{
        background-color:${C.HOVERBTN};
        font-size: 22px;
        width: 310px;
        height: 56px;
    }

`;

export const LogoCopa = styled.img`
    max-width: 300px;
    width: 90%;
    height: auto;
    margin-bottom: 10px;

    @media only screen and (max-width: 480px) {
        max-width: 150px;
    }
`;

export const LogoKnauf = styled.img`
    width: 150px;
`;

export const IconFlag = styled.img`
    width: 50px;
    height: 50px;
`;

export const Title = styled.h1`
    font-size: ${F.SIZE_TITLE};
    font-weight: bold;
    color:${C.TITLE_FONT};
    width:80%;
    margin: 2rem auto;
`;

export const SubTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: bold;
    text-align:center;
    color:${C.SECONDARY};
    margin:0px;
`;

export const TitleDarkBlue = styled.h2`
    font-size: 1.5rem;
    font-weight: bold;
    text-align:center;
    color:${C.DARK_BLUE};
    margin:0px;
`;

export const SelectInternal = styled.select`
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 2.5;
    color: ${C.GREY_FONT};
    background-color: ${C.WHITE};
    background-clip: padding-box;
    border: 1px solid #ced4da;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    margin: 15px auto;
    box-shadow: 1px 1px 0px 0px lightgrey;
    height:62px;

    &::placeholder {
        color: ${C.GREY_FONT};
    }
    &:-ms-input-placeholder {
        color: ${C.GREY_FONT};
    }
    &::-ms-input-placeholder {
        color: ${C.GREY_FONT};
    }
`;



export const InputInternal = styled.input`
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 2.5;
    color: ${C.GREY_FONT};
    background-color: ${C.WHITE};
    background-clip: padding-box;
    border: 1px solid #ced4da;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    margin: 15px auto;
    box-shadow: 1px 1px 0px 0px lightgrey;
    max-width: 500px;

    &::placeholder {
        color: ${C.GREY_FONT};
    }
    &:-ms-input-placeholder {
        color: ${C.GREY_FONT};
    }
    &::-ms-input-placeholder {
        color: ${C.GREY_FONT};
    }
`;



// GERAL - Mais de uma tela usando


   



    export const Content = styled.div`
        width:80%;
        height: 100%;
        margin-left:20%;
        padding: 0;
        max-width: 100%;
        display:flex;
        flex-direction:column;
    `;

    export const ContentChild = styled.div`
        width:100%;
        padding: 0;
        margin: 0;
        display:flex;
        flex-direction:column;
        flex:5;
    `;

 

    

// HEADER
    export const HEADER = styled.div`
        width:100%;
        max-width:100%;
        background-image: linear-gradient(${C.SECONDARY}, ${C.PRIMARY});
        padding:0;
        margin:0;
        height: 80px;
        display: flex;
        justify-content: center;
    `;
    
    export const ContainerIMG =styled.div`
        width:100%;
        text-align: center;
    `;

    export const CenterItem =styled.div`
        display:flex;
        justify-content: center;
        align-items:center
    `;

    

// REGULAMENTO 
    export const InfosRegulament = styled.p`
        margin: 0;
        font-size: 0.8rem;
        color:${C.GREY};
        margin-left: 20px;
    `;

    export const SubSubTitle = styled.h3`
        font-size: 1rem;
        font-weight: bold;
        text-align:center;
        color:${C.SECONDARY};
        margin:0px;
        margin-left: 20px;
        margin-top: 20px;
    `;

    export const SubSubTitleDark = styled.h3`
        font-size: 1rem;
        font-weight: bold;
        text-align:center;
        color:${C.DARK_BLUE};
        margin:0px;
        margin-left: 20px;
        margin-top: 20px;
    `;

    export const LiRegulament = styled.li`
        margin: 0;
        font-size: 0.8rem;
        color:${C.GREY};
        margin-left: 20px;
    `;

// MY PROFILE 
    export const BoxGrey = styled.div`
        width: 90%;
        min-height: 300px;
        margin: 0 7px 20px;
        border: solid 1px ${C.GREY_BOX}; 
    `;

    export const SmallTitle = styled.h4`
        font-size: 1rem;
        color:${C.SECONDARY};
        margin: 5px 0 2px 0
    `;

    export const DisableText = styled.h3`
        font-size: 1.5rem;
        color:${C.GREY_FONT};
        margin: 0 0 30px 0;
    `;

    export const Flex = styled.div`
        display:flex;
    `

// FOOTER
    export const Footer = styled.div`
       display:flex;
       justify-content: center;
       align-items: center;
       padding: 60px 0;
    `;


// RESULTS
    export const DATA_GAME = styled.div`
        background-color:${C.GREEN};
        cursor:pointer;
        margin-bottom:20px;
    `;

    export const InfoMatch = styled.div`
        background-color:${C.PRIMARY};
        color:${C.WHITE};
        width: 60%;
        margin-left: 10px;
        justify-content: center;
        align-items: center;
        display: flex;
        font-size: 0.8rem;
        font-weight: 800;
        height: 45px;
        margin-bottom: -15px;
        position: relative;
    `;

    export const BoxMatch = styled.div`
        background-color:${C.WHITE};
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
        width: 460px;
        min-height: 100px;
        height: 144px;
        padding: 0 10px;
    `

    export const BoxMatchTeam = styled.div`
        display: flex;
        justify-content: center;
        align-items: center;
        flex:5;
        padding-top: 25px;
    `
    
    export const TEAM = styled.p`
        color:${C.GREY};
        margin: 0 10px;
        font-size:1.2rem;
        font-weight:800;
    `

    export const InputMatch = styled.input`
        border: 1px solid #ced4da;
        width:35px;
        height:50px;
        text-align: center;
        font-size: 1.8rem;
        color:${C.GREY}
    `

    export const BoxBlocks = styled.div`
        flex-wrap: wrap;
        display:flex;
        max-width: 100%;
        align-items: center;
        justify-content: center;
    `

    export const InputDate = styled.input`
        margin-left: 20px;
        font-size: 18px;
        background-color: transparent;
        color: ${C.WHITE};
        font-weight: 800;
        border: none;

        &:focus {
            outline: none;
        }
    `

// RANKING 
    export const BoxWhite = styled.div`
        width: 90%;
        min-height: 160px;
        background-color:${C.WHITE};
        padding: 5px;
        margin: 30px auto;
        box-shadow: 1px 1px 2px 1px lightgrey;
    `

    export const TableRankingFull = styled.table`
        width:100%;
        border-collapse: collapse;
    `

    export const Thead = styled.thead`

    `

    export const TH = styled.th`
        text-align:center;
    
    `

    export const TR = styled.tr`
        text-align:center;
        height: 70px;
    `
    export const TD = styled.td`
        text-align:center;

`





// DASH






export const Container = styled.div`
width:100%;
background-image: linear-gradient(${C.SECONDARY}, ${C.PRIMARY});
padding:0;
margin:0;
display:flex;
justify-content: center;
align-items: center;
height: 100%;
flex-direction: column;
`;



























export const SaveButtom = styled.button`
  font-size: 22px;
  font-weight: bold;
  text-align:center;
  color:#FFF;
  margin-left:15px;
`;



export const AMenu = styled.a`
  font-size: 22px;
  font-weight: bold;
  text-align:center;
  color:#FFF;
  margin-left:15px;
`;

export const LiMenu = styled.li`
  font-size: 22px;
  font-weight: bold;
  text-align:center;
  color:#FFF;
  margin-left:15px;
`;

